import withLazy from 'hoc/withLazy';

export const TournamentComponent = withLazy(
    () => import(/* webpackChunkName: "tournament-Tournament" */ './Tournament')
);
